import React, { useContext } from 'react'
import { BsType } from 'react-icons/bs'
import { EditorContext } from '../../../../../../../components/CanvasEditor/Context/EditorProvider'

const FontSize = () => {

  const { textEditorOptions, setTextEditorOptions } = useContext(EditorContext)

  const handleChange = (e) => {
    setTextEditorOptions({ ...textEditorOptions, fontSize: e.target.value });
  }

  return (
    <div className='font-size' data-toggle="tooltip" data-placement="top" title="Font Size">
      <label><BsType /></label>
      <input type='number' value={textEditorOptions.fontSize} onChange={handleChange} />
    </div>
  )
}

export default FontSize